import React, { useState, useEffect, useRef  } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, collection, addDoc} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import { TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


const New = () => {

  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const [like, setLike] = useState("")

  const [invitefriend, setInvitefriend] = useState("")
  
  const [inviteOutlet, setInviteOutlet] = useState("")

  const [status, setStatus] = useState("active")

  const [createdAt, setCreatedAt] = useState(new Date())

  const [errorLike, setErrorLike] = useState(false)

  const [errorInvitefriend, setErrorInvitefriend] = useState(false)

  const [errorInviteOutlet, setErrorInviteOutlet] = useState(false)

  const navigate = useNavigate();


    
    const handles = async(e) => {
  
      e.preventDefault()

      if(like === ""){
        
        return setErrorLike("Like is required")
      }

       if(invitefriend === ""){
        
        return setErrorInvitefriend("Invitefriend is required")
      }

      if(inviteOutlet === ""){
        
        return setErrorInviteOutlet("InviteOutlet is required")
      }


      setIsloading(true)
  
      try{
           
         const advertResponse = await addDoc(collection(db, "pointcenter"), {
        
          like: like,
          invitefriend: invitefriend,
          inviteOutlet: inviteOutlet,
          status: status,
          createdAt : today,
          
        });

        setIsloading(false)

        navigate("/coin")
        
      }catch (err) {

        console.log(err);

      } 
  
    }

    const handleLike = (e) => {

          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setLike(onlyNums)

         if(like !== ""){

          setErrorLike(false)
          
         }

    }

    
    const handleInvitefriend = (e) => {

         
          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setInvitefriend(onlyNums )

         if(invitefriend !== ""){

          setErrorInvitefriend(false)
          
         }

    }


    const handleInviteOutlet = (e) => {

         
          const { value } = e.target; 
          
          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setInviteOutlet(onlyNums )

         if(inviteOutlet !== ""){

          setErrorInviteOutlet(false)
          
         }    

      }



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Point</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/coin"
            >
              Point List
            </Link>
            <Typography color="green">New Point</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
        <div className='right'>
          <div className='form'>

                <div style={{display: 'flex', flexDirection:'row', width: '100%', gap:20, flexWrap:'wrap'}}>


                  
                  
                    <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} 
                          name="like"
                          placeholder="Enter Like Point eg 60"
                          value={like}
                          onChange={handleLike}
                          style={{width:'100%', backgroundColor:'#f9e3ff'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorLike &&

                          <p style={{color:'red', fontSize:15, }}>{errorLike}</p>

                        }

                    </div>

                    <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="invitefriend"
                          placeholder="Enter Invitefriend Point eg 80"
                          value={invitefriend}
                          onChange={handleInvitefriend}
                          style={{width:'100%', backgroundColor:'#f9e3ff'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorInvitefriend &&

                          <p style={{color:'red', fontSize:15, }}>{errorInvitefriend}</p>

                        }

                    </div>


                     <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="inviteOutlet"
                          placeholder="Enter Invite Outlet Point eg 80"
                          value={inviteOutlet}
                          onChange={handleInviteOutlet}
                          style={{width:'100%', backgroundColor:'#f9e3ff'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorInviteOutlet &&

                          <p style={{color:'red', fontSize:15, }}>{errorInviteOutlet}</p>

                        }

                      </div>


                
                </div>

                <hr style={{width:'100%', height:0, color:'$eee'}}/>

                  <Button 
                  
                    onClick={handles} 
                    disabled={isloading}
                    style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>
                    {isloading ? '...loading Point' : 'Save Points'}
                    
                  </Button>

          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default New
